const locale = require('./emailTemplateModal.i18n.json');

/*@ngInject*/
const EmailTemplateModalController = function ($rootScope, $scope, coreConstant, submissionId, correspondenceFormId, collaborationMediator, currentSubmissionModel, loadingBarHandler, formViewerModel) {

    $scope.i18n = locale;
    $scope.title = $scope.i18n.title;
    $scope.createEmailButton = $scope.i18n.createEmailButton;
    $scope.cancelButton = $scope.i18n.cancelButton;

    $scope.formId = correspondenceFormId;
    $scope.submissionId = submissionId;

    $scope.effectiveDate = currentSubmissionModel.getCurrentSubmission().effectiveDate;
    $scope.currencyCode = currentSubmissionModel.getCurrentSubmission().currencyCode;

    $scope.canEnableConfirmButton = function () {
        let formStructure = formViewerModel.getFormStructure($scope.formId);
        if (formStructure && formStructure.formModel && formStructure.formModel.totalRequiredFieldCount === 0) {
            return true;
        }
        return false;
    };

    $scope.onConfirm = function () {
        loadingBarHandler.showLoadingBar($scope.i18n.loadingBar);
        collaborationMediator.createCorrespondenceEmail($scope.submissionId).then(function () {
            loadingBarHandler.hideLoadingBar();
            $scope.$close();
        });
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('emailTemplateModalController', EmailTemplateModalController);
